// Player URL helpers.
//
// One of the recurring bug-classes in signage devices is platforms that
// strip URL fragments (Fire TV / Amazon Signage Stick / older Android
// WebViews). We therefore embed the player token in BOTH the query
// string AND the fragment:
//
//     /play/:screenId?t=<token>#t=<token>
//
// The PlayerPage parses fragment-first then query, scrubs both via
// history.replaceState immediately on first load, and persists the
// token under localStorage. This module is the single source of truth
// for that URL shape — used by:
//   * the admin "copy player URL" button
//   * the Raspberry Pi /provision flow
//   * tests

const PLAY_PATH = '/play';

/**
 * Build the fully-qualified player URL for the given screen + token.
 * `origin` should be a `protocol://host[:port]` string, no trailing slash
 * required.
 */
export function buildPlayerUrl(origin: string, screenId: string, token: string): string {
  const base = origin.replace(/\/$/, '');
  const enc = encodeURIComponent(token);
  return `${base}${PLAY_PATH}/${encodeURIComponent(screenId)}?t=${enc}#t=${enc}`;
}

/**
 * Build the path-only (no origin) form of the player URL. Useful for
 * persisting in config files where the device already knows its origin.
 */
export function buildPlayerPath(screenId: string, token: string): string {
  const enc = encodeURIComponent(token);
  return `${PLAY_PATH}/${encodeURIComponent(screenId)}?t=${enc}#t=${enc}`;
}
